<p-toast>
  <ng-template let-message pTemplate="message">
    <div class="flex items-center gap-2">
      <i [class]="toastIcon(message.severity)"></i>
      <span>{{ message.summary }}</span>
    </div>
  </ng-template>
</p-toast>
<router-outlet />
